export default "<app-menu></app-menu>\n<router-outlet></router-outlet>\n"